// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const queryParams: Record<string, any> = new Proxy(
  // eslint-disable-next-line no-restricted-globals
  new URLSearchParams(window.location.search),
  {
    get: (searchParams, prop: string) => searchParams.get(prop),
  }
);
